module.exports = __webpack_public_path__ + "static/media/ten.a98da1ca.svg";